import naja from "naja"
import MiniLazyload from "minilazyload";

export default class LazyloadExtension {
    constructor(naja) {
        naja.addEventListener('init', (e) => {
            this.initLazyload(e);
        });

        naja.addEventListener('complete', this.endAjax);
    }

    static loadLazyload() {
        new MiniLazyload({
            rootMargin: '400px',
            threshold: .5,
        });
    }

    initLazyload = (e) => {
        LazyloadExtension.loadLazyload();
    };

    endAjax = (e) => {
        LazyloadExtension.loadLazyload();
    };

}